export interface LandingLayoutProps {
  children: React.ReactNode
}

export const useLandingLayout = (props: LandingLayoutProps) => {
  return {
    ...props,
  }
}
